import { apiRequest } from './client';
import type { CreatorPublicDto, LoginResponse } from './types';

export const authApi = {
  login(email: string, password: string): Promise<LoginResponse> {
    return apiRequest<LoginResponse>('/creators/auth/login', {
      method: 'POST',
      body: { email, password },
    });
  },

  changePassword(
    currentPassword: string,
    newPassword: string,
  ): Promise<{ token: string; creator: CreatorPublicDto }> {
    return apiRequest('/creators/auth/change-password', {
      method: 'POST',
      body: { currentPassword, newPassword },
    });
  },
};
